import { __rest } from "tslib";
import classNames from 'classnames';
import * as React from 'react';
import { ConfigContext } from '../config-provider';
import LocaleReceiver from '../locale-provider/LocaleReceiver';
import useBuriedPoint from '../_util/hooks/useBuriedPoint';
import DefaultEmptyImg from './empty';
import SimpleEmptyImg from './simple';
import NoContentEmptyImg from './noContent';
import NoDataEmptyImg from './noData';
const defaultEmptyImg = React.createElement(DefaultEmptyImg, null);
const simpleEmptyImg = React.createElement(SimpleEmptyImg, null);
const noContentEmptyImg = React.createElement(NoContentEmptyImg, null);
const noDataEmptyImg = React.createElement(NoDataEmptyImg, null);
const Empty = (_a) => {
    var { className, prefixCls: customizePrefixCls, image = defaultEmptyImg, description, children, imageStyle } = _a, restProps = __rest(_a, ["className", "prefixCls", "image", "description", "children", "imageStyle"]);
    useBuriedPoint('Empty');
    const { getPrefixCls, direction } = React.useContext(ConfigContext);
    return (React.createElement(LocaleReceiver, { componentName: "Empty" }, (locale) => {
        const prefixCls = getPrefixCls('empty', customizePrefixCls);
        const des = typeof description !== 'undefined' ? description : locale === null || locale === void 0 ? void 0 : locale.description;
        const alt = typeof des === 'string' ? des : 'empty';
        let imageNode = null;
        if (typeof image === 'string') {
            imageNode = React.createElement("img", { alt: alt, src: image });
        }
        else {
            imageNode = image;
        }
        return (React.createElement("div", Object.assign({ className: classNames(prefixCls, {
                [`${prefixCls}-normal`]: image === simpleEmptyImg,
                [`${prefixCls}-rtl`]: direction === 'rtl',
            }, className) }, restProps),
            React.createElement("div", { className: `${prefixCls}-image`, style: imageStyle }, imageNode),
            des && React.createElement("div", { className: `${prefixCls}-description` }, des),
            children && React.createElement("div", { className: `${prefixCls}-footer` }, children)));
    }));
};
Empty.PRESENTED_IMAGE_DEFAULT = defaultEmptyImg;
Empty.PRESENTED_IMAGE_SIMPLE = simpleEmptyImg;
Empty.PRESENTED_IMAGE_NOCONTENT = noContentEmptyImg;
Empty.PRESENTED_IMAGE_NODATA = noDataEmptyImg;
export default Empty;
